import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhotoBackgroundMonogramLayout = loadable(
  () => import(/* webpackChunkName: "content/guest/header/photoBackgroundMonogram" */ './PhotoBackgroundMonogram'),
  'PhotoBackgroundMonogramLayout',
);
